import { css } from 'linaria';

export const utpCardText = css`
  @media (--from-tablet) {
    white-space: pre-line;
  }

  @media (--only-mobile) {
    white-space: break-spaces;
  }
`;

export const desktopCardText = css`
  @media (--to-desktop) {
    display: none;
  }
`;

export const mobileCardText = css`
  display: none;

  @media (--to-desktop) {
    display: block;
  }
`;
